(() => {
  'use strict';

  const PAINTS = {
    t5: [
      ['Grey White', '#d8d8ce'], ['Spectral Yellow', '#e5c52a'],
      ['Bright Orange', '#d96b21'], ['Tornado Red', '#c72b32'],
      ['Paprika Red', '#8f3431'], ['Spanish Red', '#ae2c34'],
      ['Flannel Grey', '#747873'], ['Danish Blue', '#3a5f7a'],
      ['Indian Blue', '#31597d'], ['Steel Blue', '#456a79'],
      ['Lime', '#96a844'], ['Friesen Green', '#52756c'],
      ['Sea Green', '#4e6f67'], ['Stone Blue', '#5d6b77'],
      ['Deep Black', '#1b1d1e'], ['Black', '#111214'],
      ['Oxide Silver Metallic', '#9da2a0'], ['Reflex Silver Metallic', '#aeb3b3'],
      ['Wheat Beige Metallic', '#a79579'], ['Fresco Green Metallic', '#84958b'],
      ['Pine Green Metallic', '#344d43'], ['Off-road Grey Metallic', '#6c6b65'],
      ['Raven Blue Metallic', '#263d58'], ['Shadow Blue Metallic', '#50657a'],
      ['Tibet Red Pearl', '#70363c'], ['Berry Red Pearl', '#673848'],
      ['Mistral Blue Pearl', '#324862'], ['Night Black Pearl', '#1b1e21'],
      ['Diamond Black Pearl', '#17191b']
    ],
    t51: [
      ['Candy White', '#e7e4d9'], ['Pure Grey', '#92928b'], ['Sunny Yellow', '#e3b827'],
      ['Bright Orange', '#d96b21'], ['Salsa Red', '#a52d31'], ['Indian Blue', '#31597d'],
      ['Ontario Green', '#607a70'], ['Black', '#111214'], ['Danish Blue', '#3a5f7a'],
      ['Stone Blue', '#5d6b77'], ['Grey White', '#d8d8ce'],
      ['Natural Grey Metallic', '#777873'], ['Reflex Silver Metallic', '#aeb3b3'],
      ['Night Blue Metallic', '#263a55'], ['Sand Beige Metallic', '#aa9a80'],
      ['Toffee Brown Metallic', '#57463d'], ['Olympian Blue Metallic', '#477b94'],
      ['Dark Wood Pearl', '#4d403a'], ['Deep Black Pearl', '#1b1d1e'],
      ['Glacier Blue', '#7aa4b8']
    ],
    t6: [
      ['Candy White', '#e7e4d9'], ['Grape Yellow', '#d8c82d'], ['Bright Orange', '#d96b21'],
      ['Cherry Red', '#9c2d32'], ['Pure Grey', '#92928b'], ['Summer Blue', '#6e9db8'],
      ['Deep Ocean', '#365269'], ['Acapulco Blue Metallic', '#37758b'],
      ['Bamboo Garden Green Metallic', '#667c70'], ['Chestnut Brown Metallic', '#5d4940'],
      ['Indium Grey Metallic', '#6c7070'], ['Mojave Beige Metallic', '#a99d89'],
      ['Reflex Silver Metallic', '#adb1b0'], ['Starlight Blue Metallic', '#283e56'],
      ['Deep Black Pearl', '#1b1d1e'], ['Oryx White Pearl', '#f0eee4']
    ],
    t61: [
      ['Candy White', '#e7e4d9'], ['Ascot Grey', '#aaa99e'], ['Bright Orange', '#d96b21'],
      ['Cherry Red', '#9c2d32'], ['Pure Grey', '#92928b'], ['Bay Leaf Green Metallic', '#71806d'],
      ['Copper Bronze Metallic', '#816557'], ['Fortana Red Metallic', '#83383b'],
      ['Indium Grey Metallic', '#6c7070'], ['Mojave Beige Metallic', '#a99d89'],
      ['Ravenna Blue Metallic', '#29627c'], ['Reflex Silver Metallic', '#adb1b0'],
      ['Starlight Blue Metallic', '#283e56'], ['Deep Black Pearl', '#1b1d1e']
    ]
  };

  const GENERATIONS = { t5: 'T5', t51: 'T5.1', t6: 'T6', t61: 'T6.1' };

  const COVER_COLOURS = { black: '#171817', grey: '#737675' };

  // Sampled from the product's iris swatch photography so the preview follows
  // the material colours customers choose rather than a generic UI palette.
  const EYE_COLOURS = {
    yellow: '#cfb020', red: '#ce193e', purple: '#2f2e88',
    'light-pink': '#daa9bc', 'royal-blue': '#17439f', orange: '#ed9a3b',
    'light-blue': '#4e8eb8', turquoise: '#21799a', brown: '#72493e',
    lime: '#8fdf66', 'bottle-green': '#3c5932', green: '#429945', grey: '#666a6e'
  };

  const LEGACY_COVER_POLYGON = [
    [.265, .085], [.735, .085], [.755, .105], [.793, .350],
    [.775, .360], [.225, .360], [.207, .350], [.245, .105]
  ];

  // Both T4 front styles share the T5-proportioned windscreen and fitted-cover
  // coordinates. Keep a dedicated polygon so future T4 refinements cannot
  // change the legacy T5/T6 blank-cover fallback.
  const T4_COVER_POLYGON = [
    [.270, .063], [.340, .055], [.430, .051], [.570, .051],
    [.660, .055], [.730, .063], [.755, .082], [.805, .355],
    [.790, .368], [.210, .368], [.195, .355], [.245, .082]
  ];

  // T7 and Transit Custom masters deliberately extend the complete fitted
  // cover over the windscreen pillars. The blank master is dark rather than
  // chromatic, so its neutral recolour fallback must follow the larger fit.
  const FULL_FIT_COVER_POLYGON = [
    [.237, .060], [.763, .060], [.786, .082], [.828, .349],
    [.808, .360], [.192, .360], [.172, .349], [.214, .082]
  ];

  // The Bay Window's fitted cover follows a taller, more rounded single-piece
  // windscreen than the modern vans. This fallback is used only by the blank
  // neutral master; every named eye design carries an explicit colour mask.
  const T2_BAY_COVER_POLYGON = [
    [.2500, .3613], [.2539, .3125], [.2624, .2373],
    [.2793, .1563], [.2936, .1104], [.3503, .0957],
    [.5000, .0869], [.6549, .0957], [.7240, .1104],
    [.7487, .1563], [.7656, .2373], [.7773, .3125],
    [.7813, .3613]
  ];

  // The T1's external cover spans both split windscreens and passes over the
  // fixed centre pillar. This fallback is used only for the blank neutral
  // master; named designs carry their chromatic cover mask in the artwork.
  const T1_SPLIT_COVER_POLYGON = [
    [.2552, .3154], [.2585, .2734], [.2624, .2197],
    [.2676, .1660], [.2754, .1260], [.2884, .1055],
    [.3125, .0967], [.5000, .0928], [.6875, .0967],
    [.7116, .1055], [.7246, .1260], [.7324, .1660],
    [.7376, .2197], [.7415, .2734], [.7448, .3154]
  ];

  // The T25/T3 cover follows the broad, shallow windscreen on both the early
  // round-headlamp and late rectangular-headlamp fronts. This polygon is only
  // a neutral recolour fallback for the blank masters.
  const T25_COVER_POLYGON = [
    [.2600, .0600], [.7400, .0600],
    [.7750, .0780], [.7920, .1200], [.8020, .2000],
    [.8060, .3050], [.7920, .3260],
    [.2080, .3260], [.1940, .3050], [.1980, .2000],
    [.2080, .1200], [.2250, .0780]
  ];

  // The 2017+ Crafter master preserves the tall vehicle proportions on a
  // 1200 × 800 canvas. Its cover is fitted independently from the T5/T6 art
  // so the neutral blank fallback reaches the Crafter windscreen edges.
  const CRAFTER_2017_COVER_POLYGON = [
    [.2907, .1179], [.3544, .1109], [.4363, .1074], [.5637, .1074],
    [.6456, .1109], [.7093, .1179], [.7184, .1347], [.7503, .3749],
    [.2498, .3749], [.2816, .1347]
  ];

  // The 2006–2018 Sprinter cover starts at the roof, widens down the
  // A-pillars, reaches the mirrors and finishes in the wiper well.
  const SPRINTER_2006_COVER_POLYGON = [
    [.3576, .114], [.3920, .105], [.4504, .101], [.5496, .101],
    [.6080, .105], [.6424, .114],
    [.6616, .146], [.6784, .230], [.6952, .338], [.7080, .410],
    [.2920, .410], [.3048, .338], [.3216, .230], [.3384, .146]
  ];

  // Non-blank Sprinter masters keep the approved eye artwork at 90% inside
  // the full fitted cover. This inner silhouette lets the neutral outer ring
  // follow the selected cover colour without changing the eye scale.
  const SPRINTER_2006_EYE_ART_POLYGON = [
    [.37184, .1426], [.4028, .1345], [.45536, .1309], [.54464, .1309],
    [.5972, .1345], [.62816, .1426],
    [.64544, .1714], [.66056, .2470], [.67568, .3442], [.6872, .4090],
    [.3128, .4090], [.32432, .3442], [.33944, .2470], [.35456, .1714]
  ];
  const SPRINTER_2006_EYE_ART_SEAM_OUTSET = SPRINTER_2006_EYE_ART_POLYGON.map(
    ([x, y]) => [
      .5 + (x - .5) * 1.02,
      .27 + (y - .27) * 1.04
    ]
  );
  const SPRINTER_2006_EYE_ART_SEAM_INSET = SPRINTER_2006_EYE_ART_POLYGON.map(
    ([x, y]) => [
      .5 + (x - .5) * .985,
      .27 + (y - .27) * .97
    ]
  );
  const SPRINTER_2006_EYE_ART_SEAM_BOTTOM = .398;

  // The T1 source photograph contains turquoise reflections in its badge,
  // lamps and chrome. Restrict its iris sentinel to the approved eye artwork
  // so changing eye colour can never recolour the vehicle underneath.
  const T1_SPLIT_IRIS_ROI = [.2700, .1600, .7300, .3250];
  const CRAFTER_2017_IRIS_ROI = [.2800, .1800, .7200, .3800];
  const SPRINTER_2006_IRIS_ROI = [.2850, .1900, .7150, .4050];

  // The approved masters use three deliberately chromatic source colours.
  // Their dark/white artwork is final and must never be inferred or recoloured.
  const SENTINELS = {
    paint: { hue: [285, 300, 340, 352], saturation: [.22, .52], value: [.14, .30] },
    cover: { hue: [58, 68, 105, 118], saturation: [.24, .52], value: [.22, .40] },
    iris: { hue: [168, 178, 212, 224], saturation: [.22, .50], value: [.16, .34] }
  };

  // Frida and Sophie deliberately use a contrasting neutral feature fill.
  // These narrow source-value bands are evaluated only inside the feature
  // artwork region. Pupils, flecks and black outlines fall outside the band.
  const CONTRAST_FEATURES = {
    frida: {
      roi: [.215, .175, .785, .325],
      luminance: [42, 50, 70, 80]
    },
    sophie: {
      roi: [.215, .175, .785, .325],
      luminance: [60, 70, 104, 116]
    }
  };
  const CRAFTER_2017_CONTRAST_FEATURES = {
    sophie: {
      // The Crafter fit places the outer lash tips slightly lower than the
      // T5/T6 master. Include their complete neutral fill without widening
      // the mask into the chromatic cover or white eye panels.
      roi: [.215, .175, .785, .365],
      luminance: [60, 70, 104, 116]
    }
  };
  const SPRINTER_2006_CONTRAST_FEATURES = {
    frida: {
      // The scaled Sprinter fit places Frida's outer lash tips slightly below
      // the shared T5 feature ROI. Include the complete monobrow and all lash
      // fills while keeping the white eye panels outside this neutral mask.
      roi: [.215, .175, .785, .365],
      extraRois: [
        [.245, .350, .315, .435],
        [.705, .350, .775, .435]
      ],
      luminance: [42, 50, 70, 80]
    },
    sophie: {
      // Sophie uses separate lashes whose curved fill sits lower than the
      // monobrow. The outer tips include dark, compressed pixels that must be
      // forced black on a grey cover, while the narrower contrast mask keeps
      // the approved black edging intact when the cover itself is black.
      roi: [.215, .175, .785, .395],
      extraRois: [
        [.245, .350, .315, .475],
        [.705, .350, .775, .475]
      ],
      luminance: [44, 52, 124, 134],
      darkenExtraLuminance: [0, 0, 124, 144],
      darkenExtraChroma: [12, 32]
    }
  };

  const slug = value => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  const isSprinterGeneration = generationKey =>
    generationKey === 'mercedes-sprinter-2006' ||
    generationKey === 'mercedes-sprinter-2018';

  const clamp = (value, min = 0, max = 255) => Math.max(min, Math.min(max, value));
  const lerp = (start, end, amount) => start + (end - start) * amount;

  function smoothstep(edge0, edge1, value) {
    if (edge0 === edge1) return value < edge0 ? 0 : 1;
    const t = clamp((value - edge0) / (edge1 - edge0), 0, 1);
    return t * t * (3 - 2 * t);
  }

  const band = (value, edges) =>
    smoothstep(edges[0], edges[1], value) * (1 - smoothstep(edges[2], edges[3], value));

  function hexToRgb(hex) {
    const clean = String(hex || '#000000').replace('#', '');
    return [0, 2, 4].map(offset => parseInt(clean.slice(offset, offset + 2), 16) || 0);
  }

  function rgbToHsv(r, g, b, result) {
    const rn = r / 255;
    const gn = g / 255;
    const bn = b / 255;
    const max = Math.max(rn, gn, bn);
    const min = Math.min(rn, gn, bn);
    const delta = max - min;
    let hue = 0;

    if (delta) {
      if (max === rn) hue = 60 * (((gn - bn) / delta) % 6);
      else if (max === gn) hue = 60 * (((bn - rn) / delta) + 2);
      else hue = 60 * (((rn - gn) / delta) + 4);
    }

    if (hue < 0) hue += 360;
    result[0] = hue;
    result[1] = max ? delta / max : 0;
    result[2] = max;
  }

  function pointInPolygon(x, y, polygon) {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0];
      const yi = polygon[i][1];
      const xj = polygon[j][0];
      const yj = polygon[j][1];
      const intersects = ((yi > y) !== (yj > y)) &&
        (x < (xj - xi) * (y - yi) / ((yj - yi) || Number.EPSILON) + xi);
      if (intersects) inside = !inside;
    }
    return inside;
  }

  function pointInRois(x, y, rois) {
    for (let index = 0; index < rois.length; index += 1) {
      const roi = rois[index];
      if (x >= roi[0] && x <= roi[2] && y >= roi[1] && y <= roi[3]) return true;
    }
    return false;
  }

  function compactMask(mask) {
    let count = 0;
    for (let index = 0; index < mask.length; index += 1) {
      if (mask[index]) count += 1;
    }

    const pixels = new Uint32Array(count);
    const alphas = new Uint8Array(count);
    let target = 0;
    for (let index = 0; index < mask.length; index += 1) {
      if (!mask[index]) continue;
      pixels[target] = index;
      alphas[target] = mask[index];
      target += 1;
    }
    return { pixels, alphas };
  }

  function tintPixel(bytes, index, target, alpha, kind) {
    if (alpha <= 0) return;
    const r = bytes[index];
    const g = bytes[index + 1];
    const b = bytes[index + 2];
    const luminance = .2126 * r + .7152 * g + .0722 * b;

    if (kind === 'sprinter-cover') {
      for (let channel = 0; channel < 3; channel += 1) {
        bytes[index + channel] = Math.round(
          lerp(bytes[index + channel], target[channel], alpha)
        );
      }
      return;
    }

    if (kind === 'cover' || kind === 'blank-cover') {
      const baseline = kind === 'cover' ? 194 : 24;
      const strength = kind === 'cover' ? .55 : .45;
      const texture = (luminance - baseline) * strength;

      for (let channel = 0; channel < 3; channel += 1) {
        const destination = clamp(target[channel] + texture);
        bytes[index + channel] = Math.round(lerp(bytes[index + channel], destination, alpha));
      }
      return;
    }

    const value = Math.max(r, g, b) / 255;
    const shade = .34 + value * .92;
    const highlight = Math.max(0, (value - .78) / .22) * (kind === 'paint' ? .22 : .10);

    for (let channel = 0; channel < 3; channel += 1) {
      const destination = clamp(target[channel] * shade + 255 * highlight);
      bytes[index + channel] = Math.round(lerp(bytes[index + channel], destination, alpha));
    }
  }

  function darkenBrow(bytes, index, alpha) {
    const luminance = (bytes[index] + bytes[index + 1] + bytes[index + 2]) / 3;
    const destination = clamp(12 + luminance * .12, 14, 30);
    for (let channel = 0; channel < 3; channel += 1) {
      bytes[index + channel] = Math.round(lerp(bytes[index + channel], destination, alpha));
    }
  }

  function lightenBrow(bytes, index, alpha) {
    const luminance = (bytes[index] + bytes[index + 1] + bytes[index + 2]) / 3;
    const destination = clamp(54 + luminance * .4, 72, 92);
    for (let channel = 0; channel < 3; channel += 1) {
      bytes[index + channel] = Math.round(lerp(bytes[index + channel], destination, alpha));
    }
  }

  const yieldToBrowser = () => new Promise(resolve => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(resolve, { timeout: 32 });
    else window.setTimeout(resolve, 0);
  });

  async function decodeArtwork(url) {
    if ('createImageBitmap' in window) {
      try {
        const response = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error(`Artwork request failed (${response.status})`);
        const bitmap = await createImageBitmap(await response.blob());
        const canvas = document.createElement('canvas');
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(bitmap, 0, 0);
        bitmap.close();
        return context.getImageData(0, 0, canvas.width, canvas.height);
      } catch (error) {
        if (error && error.name === 'SecurityError') throw error;
      }
    }

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.decoding = 'async';
    const loaded = new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = () => reject(new Error('Artwork image could not be loaded'));
    });
    image.src = url;
    await loaded;
    const canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0);
    return context.getImageData(0, 0, canvas.width, canvas.height);
  }

  const sentinelAlpha = (hue, saturation, value, sentinel) =>
    band(hue, sentinel.hue) *
    smoothstep(sentinel.saturation[0], sentinel.saturation[1], saturation) *
    smoothstep(sentinel.value[0], sentinel.value[1], value);

  async function buildSentinelMasks(source, styleKey, generationKey, isCurrent) {
    const width = source.width;
    const height = source.height;
    const length = width * height;
    const paint = new Uint8Array(length);
    const cover = new Uint8Array(length);
    const iris = new Uint8Array(length);
    const neutralCover =
      isSprinterGeneration(generationKey) && styleKey !== 'blank' ?
        new Uint8Array(length) :
        null;
    const coverSeam = neutralCover ? new Uint8Array(length) : null;
    const contrastSpec =
      (isSprinterGeneration(generationKey) &&
        SPRINTER_2006_CONTRAST_FEATURES[styleKey]) ||
      ((generationKey === 'vw-crafter-2017' ||
        generationKey === 'man-tge-2017') &&
        CRAFTER_2017_CONTRAST_FEATURES[styleKey]) ||
      CONTRAST_FEATURES[styleKey];
    const contrast = contrastSpec ? new Uint8Array(length) : null;
    const contrastDark = contrastSpec?.darkenExtraLuminance ?
      new Uint8Array(length) :
      null;
    const data = source.data;
    const hsv = new Float32Array(3);
    const blankCoverPolygon = generationKey === 'vw-t1-split' ?
      T1_SPLIT_COVER_POLYGON :
      generationKey === 'vw-t2-bay' ?
        T2_BAY_COVER_POLYGON :
      generationKey === 'vw-t25-early' || generationKey === 'vw-t25-late' ?
        T25_COVER_POLYGON :
      generationKey === 'vw-t4-short-front' || generationKey === 'vw-t4-long-front' ?
        T4_COVER_POLYGON :
      generationKey === 'vw-crafter-2017' || generationKey === 'man-tge-2017' ?
        CRAFTER_2017_COVER_POLYGON :
      isSprinterGeneration(generationKey) ?
        SPRINTER_2006_COVER_POLYGON :
      generationKey === 'vw-t7' ||
        generationKey === 'ford-transit-custom-2023' ||
        generationKey === 'ford-transit-custom-2012' ||
        generationKey === 'ford-transit-custom-2018' ?
        FULL_FIT_COVER_POLYGON : LEGACY_COVER_POLYGON;

    for (let y = 0; y < height; y += 1) {
      if (y % 72 === 0) {
        if (!isCurrent()) throw new DOMException('Stale artwork build', 'AbortError');
        await yieldToBrowser();
      }

      const ny = y / height;
      for (let x = 0; x < width; x += 1) {
        const pixel = y * width + x;
        const index = pixel * 4;
        const r = data[index];
        const g = data[index + 1];
        const b = data[index + 2];
        const nx = x / width;
        const chroma = Math.max(r, g, b) - Math.min(r, g, b);
        const luminance = .2126 * r + .7152 * g + .0722 * b;
        rgbToHsv(r, g, b, hsv);

        paint[pixel] = Math.round(sentinelAlpha(hsv[0], hsv[1], hsv[2], SENTINELS.paint) * 255);
        cover[pixel] = Math.round(sentinelAlpha(hsv[0], hsv[1], hsv[2], SENTINELS.cover) * 255);
        const isSprinterEyeArtSeam =
          neutralCover &&
          ny < SPRINTER_2006_EYE_ART_SEAM_BOTTOM &&
          pointInPolygon(nx, ny, SPRINTER_2006_EYE_ART_SEAM_OUTSET) &&
          !pointInPolygon(nx, ny, SPRINTER_2006_EYE_ART_SEAM_INSET);
        if (isSprinterEyeArtSeam) coverSeam[pixel] = 255;
        const irisRoi = generationKey === 'vw-t1-split' ?
          T1_SPLIT_IRIS_ROI :
          generationKey === 'vw-crafter-2017' || generationKey === 'man-tge-2017' ?
            CRAFTER_2017_IRIS_ROI :
          isSprinterGeneration(generationKey) ?
            SPRINTER_2006_IRIS_ROI :
            null;
        const irisIsInArtwork = !irisRoi ||
          (nx >= irisRoi[0] && nx <= irisRoi[2] &&
            ny >= irisRoi[1] && ny <= irisRoi[3]);
        if (irisIsInArtwork && isSprinterGeneration(generationKey)) {
          // The approved Sprinter masters contain a textured turquoise iris.
          // A soft sentinel left some of the original blue at the darker and
          // lighter edges when customers selected purple, red or another eye
          // colour. Inside the tightly bounded eye ROI, turquoise is unique
          // to the iris, so fully include its complete chromatic range while
          // retaining a soft antialiased edge.
          const irisHueAlpha = band(hsv[0], [160, 168, 224, 232]);
          const irisChromaAlpha = smoothstep(.08, .18, hsv[1]);
          const irisValueAlpha = smoothstep(.08, .14, hsv[2]);
          iris[pixel] = Math.round(
            irisHueAlpha * irisChromaAlpha * irisValueAlpha * 255
          );
        } else {
          iris[pixel] = irisIsInArtwork ?
            Math.round(sentinelAlpha(hsv[0], hsv[1], hsv[2], SENTINELS.iris) * 255) :
            0;
        }

        // Blank artwork can safely recolour the complete neutral cover. The
        // Sprinter non-blank masters also need a separate neutral fallback for
        // the full-size fitted cover around their smaller approved eye layer.
        const isBlankNeutralCover =
          styleKey === 'blank' && pointInPolygon(nx, ny, blankCoverPolygon);
        const isSprinterOuterCover =
          neutralCover &&
          pointInPolygon(nx, ny, blankCoverPolygon) &&
          !pointInPolygon(nx, ny, SPRINTER_2006_EYE_ART_POLYGON);
        if (isSprinterOuterCover) {
          neutralCover[pixel] = 255;
        } else if (!cover[pixel] && isBlankNeutralCover) {
          const neutralAlpha = (1 - smoothstep(12, 28, chroma)) *
            band(luminance, [8, 22, 105, 145]);
          cover[pixel] = Math.round(neutralAlpha * 255);
        }

        const isInPrimaryContrastRoi = contrast &&
          nx >= contrastSpec.roi[0] && nx <= contrastSpec.roi[2] &&
          ny >= contrastSpec.roi[1] && ny <= contrastSpec.roi[3];
        const isInExtraContrastRoi = contrast &&
          pointInRois(nx, ny, contrastSpec.extraRois || []);
        const isInContrastRoi = isInPrimaryContrastRoi || isInExtraContrastRoi;
        if (isInContrastRoi) {
          const neutralAlpha = 1 - smoothstep(12, 22, chroma);
          const contrastAlpha = Math.round(
            neutralAlpha * band(luminance, contrastSpec.luminance) * 255
          );
          contrast[pixel] = contrastAlpha;
          if (contrastDark) {
            const darkenChroma = contrastSpec.darkenExtraChroma || [12, 22];
            const darkenNeutralAlpha = 1 - smoothstep(
              darkenChroma[0],
              darkenChroma[1],
              chroma
            );
            const darkenExtraAlpha = isInExtraContrastRoi ?
              Math.round(
                darkenNeutralAlpha *
                band(luminance, contrastSpec.darkenExtraLuminance) *
                255
              ) :
              0;
            contrastDark[pixel] = Math.max(contrastAlpha, darkenExtraAlpha);
          }
        }
      }
    }

    return {
      paint: compactMask(paint),
      cover: compactMask(cover),
      neutralCover: neutralCover ? compactMask(neutralCover) : null,
      coverSeam: coverSeam ? compactMask(coverSeam) : null,
      iris: compactMask(iris),
      contrast: contrast ? compactMask(contrast) : null,
      contrastDark: contrastDark ? compactMask(contrastDark) : null
    };
  }

  class KDVisualConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.renderToken = 0;
      this.masterBuildId = 0;
      this.active = false;
      this.raf = 0;
      this.masterCache = new Map();
      this.masterPromises = new Map();
      this.paintBuffer = document.createElement('canvas');

      this.stage = this.querySelector('[data-kd-stage]');
      this.canvas = this.querySelector('[data-kd-photo-canvas]');
      this.fitGuide = this.querySelector('[data-kd-fit-guide]');
      this.loading = this.querySelector('[data-kd-loading]');
      this.error = this.querySelector('[data-kd-load-error]');
      this.generation = this.querySelector('[data-kd-generation]');
      this.paint = this.querySelector('[data-kd-paint]');
      this.status = this.querySelector('[data-kd-visual-status]');
      this.generationLabel = this.querySelector('[data-kd-generation-label]');
      this.designBadge = this.querySelector('[data-kd-design-badge]');
      this.fitNote = this.querySelector('[data-kd-fit-note]');
      this.summary = this.querySelector('[data-kd-summary]');
      this.vectorVan = this.querySelector('[data-kd-van]');
      this.vectorEyes = this.querySelector('[data-kd-eyes]');
      this.optionScope = this.closest('.kd-customiser') || this.parentElement || document;
      this.i18n = {
        chooseEyeDesign: this.dataset.i18nChooseEyeDesign || 'Choose an eye design',
        chooseCoverColour: this.dataset.i18nChooseCoverColour || 'choose cover colour',
        chooseEyeColour: this.dataset.i18nChooseEyeColour || 'choose eye colour',
        summaryPrefix: this.dataset.i18nSummaryPrefix || 'Your configuration',
        coverSuffix: this.dataset.i18nCoverSuffix || 'cover',
        eyesSuffix: this.dataset.i18nEyesSuffix || 'eyes',
        screenCover: this.dataset.i18nScreenCover || 'screen',
        canvasLabel: this.dataset.i18nCanvasLabel || '{vehicle} in {paint} with {cover} {design} cover{eyes}'
      };

      // Vehicle-specific catalogue data is supplied by the product snippet.
      // The original T5–T6.1 page intentionally has no profile config and
      // therefore continues through the exact legacy constants above.
      try {
        this.profile = JSON.parse(this.querySelector('[data-kd-profile-config]')?.textContent || 'null');
      } catch (_error) {
        this.profile = null;
      }
      if (!this.profile?.generations || typeof this.profile.generations !== 'object') {
        this.profile = null;
      }

      try {
        this.artworks = JSON.parse(this.querySelector('[data-kd-artworks]')?.textContent || '{}');
      } catch (_error) {
        this.artworks = {};
      }

      this.generation?.addEventListener('change', () => {
        this.populatePaints(this.paint.value);
        this.scheduleRender();
      }, { signal: this.controller.signal });
      this.paint.addEventListener('change', () => this.scheduleRender(), { signal: this.controller.signal });
      this.optionScope.addEventListener('change', event => {
        if (!event.target.matches(
          'input[data-kd-option="cover-colour"], ' +
          'input[data-kd-option="eye-design"], ' +
          'input[data-kd-option="eye-colour"], ' +
          'input[name="properties[Cover colour]"], ' +
          'input[name="properties[Eye design]"], ' +
          'input[name="properties[Eye colour]"]'
        )) return;
        this.syncOptions();
        this.scheduleRender();
      }, { signal: this.controller.signal });
      window.addEventListener('pageshow', () => {
        this.syncOptions();
        this.scheduleRender();
      }, { signal: this.controller.signal });

      this.populatePaints(this.profile ? '' : 'Candy White');
      this.syncOptions();

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.active = true;
          this.observer.disconnect();
          this.scheduleRender();
        }, { rootMargin: '250px 0px' });
        // The custom element becomes `display: contents` in the mobile sticky
        // layout, so it has no box for IntersectionObserver to watch. Observe
        // the stage instead; it is the actual visible preview on every layout.
        this.observer.observe(this.stage || this);
      } else {
        this.active = true;
      }
      this.scheduleRender();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.observer = null;
      this.masterBuildId += 1;
      this.renderToken += 1;
      cancelAnimationFrame(this.raf);
    }

    get generationKey() {
      return this.generation?.selectedOptions[0]?.dataset.key ||
        this.profile?.defaultGeneration || this.dataset.defaultGeneration || 't61';
    }

    get generationConfig() {
      return this.profile?.generations?.[this.generationKey] || null;
    }

    get selectedPaint() {
      const option = this.paint.selectedOptions[0];
      return { name: option?.value || '', hex: option?.dataset.hex || '#e7e4d9' };
    }

    populatePaints(preferred) {
      const profilePaints = this.generationConfig?.paints;
      const paints = Array.isArray(profilePaints) && profilePaints.length ?
        profilePaints : (PAINTS[this.generationKey] || PAINTS.t61);
      const defaultPaint = this.generationConfig?.defaultPaint || 'Candy White';
      const wanted = preferred && paints.some(([name]) => name === preferred) ? preferred :
        (paints.some(([name]) => name === defaultPaint) ? defaultPaint : paints[0][0]);
      this.paint.replaceChildren(...paints.map(([name, hex]) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        option.dataset.hex = hex;
        option.selected = name === wanted;
        return option;
      }));
    }

    checkedOption(kind, propertyName) {
      return this.optionScope.querySelector(`input[data-kd-option="${kind}"]:checked`) ||
        this.optionScope.querySelector(`input[name="properties[${propertyName}]"]:checked`);
    }

    syncOptions() {
      const coverInput = this.checkedOption('cover-colour', 'Cover colour');
      const designInput = this.checkedOption('eye-design', 'Eye design');
      const eyeInput = this.checkedOption('eye-colour', 'Eye colour');

      this.coverChosen = Boolean(coverInput);
      this.designChosen = Boolean(designInput);
      this.eyeChosen = Boolean(eyeInput);
      this.coverName = coverInput?.value || 'Black';
      this.designName = designInput?.value || '';
      this.eyeName = eyeInput?.value || 'Turquoise';
      this.coverKey = slug(this.coverName);
      this.styleKey = slug(this.designName);
      this.eyeKey = slug(this.eyeName);
    }

    scheduleRender() {
      const token = ++this.renderToken;
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.render(token));
    }

    setBusy(busy) {
      this.stage.setAttribute('aria-busy', String(busy));
      this.loading.hidden = !busy;
    }

    showFitGuide(showMissingNote = false) {
      this.canvas.hidden = true;
      this.fitGuide.hidden = false;
      this.setBusy(false);
      this.error.hidden = true;
      this.fitNote.hidden = !showMissingNote;
    }

    artworkUrl(generationKey, artworkKey) {
      const generationArtworks = this.artworks[generationKey];
      if (generationArtworks && typeof generationArtworks === 'object' && !Array.isArray(generationArtworks)) {
        return generationArtworks[artworkKey] || '';
      }

      // Backwards compatibility for the original flat T6.1-only manifest.
      // Other generations must always provide their own full-vehicle masters.
      if (generationKey === 't61' && typeof this.artworks[artworkKey] === 'string') {
        return this.artworks[artworkKey];
      }
      return '';
    }

    updateText() {
      const generationConfig = this.generationConfig;
      const generation = generationConfig?.shortLabel || GENERATIONS[this.generationKey] || 'T6.1';
      const paint = this.selectedPaint;
      const coverHex = COVER_COLOURS[this.coverKey] || COVER_COLOURS.black;
      const eyeHex = EYE_COLOURS[this.eyeKey] || EYE_COLOURS.turquoise;
      const isBlank = this.styleKey === 'blank';
      const hasEyeArtwork = this.designChosen && !isBlank;

      this.stage.style.setProperty('--kd-van', paint.hex);
      this.stage.style.setProperty('--kd-cover', coverHex);
      this.stage.style.setProperty('--kd-eye', eyeHex);
      this.status.textContent = generationConfig ?
        `${generationConfig.statusLabel || generation} · ${paint.name}` :
        `VW ${generation} · ${paint.name}`;
      this.generationLabel.textContent = generationConfig?.badgeLabel || generation;
      this.designBadge.textContent = this.designChosen ? this.designName : this.i18n.chooseEyeDesign;
      this.vectorVan.setAttribute('class', `kd-van kd-van--${this.generationKey}`);
      // The vector is only a fit/loading fallback. Never represent a named
      // product design with invented generic eyes if a master cannot render.
      this.vectorEyes.dataset.design = 'blank';
      this.fitNote.hidden = true;

      const parts = [generationConfig?.summaryLabel || `${generation}`, paint.name];
      parts.push(this.coverChosen ? `${this.coverName} ${this.i18n.coverSuffix}` : this.i18n.chooseCoverColour);
      parts.push(this.designChosen ? this.designName : this.i18n.chooseEyeDesign);
      if (hasEyeArtwork) parts.push(this.eyeChosen ? `${this.eyeName} ${this.i18n.eyesSuffix}` : this.i18n.chooseEyeColour);
      this.summary.textContent = `${this.i18n.summaryPrefix}: ${parts.join(' · ')}`;
      const vehicleName = generationConfig?.vehicleName || `Volkswagen ${generation}`;
      const eyesText = hasEyeArtwork ? ` and ${this.eyeName} ${this.i18n.eyesSuffix}` : '';
      this.canvas.setAttribute(
        'aria-label',
        this.i18n.canvasLabel
          .replace('{vehicle}', vehicleName)
          .replace('{paint}', paint.name)
          .replace('{cover}', this.coverName)
          .replace('{design}', this.designName || this.i18n.screenCover)
          .replace('{eyes}', eyesText)
      );
    }

    async render(token = ++this.renderToken) {
      if (token !== this.renderToken || !this.isConnected) return;
      const state = Object.freeze({
        generationKey: this.generationKey,
        selectedPaint: this.selectedPaint,
        coverKey: this.coverKey,
        eyeKey: this.eyeKey,
        styleKey: this.styleKey,
        designChosen: this.designChosen
      });
      this.updateText();

      const artworkKey = state.designChosen && state.styleKey && state.styleKey !== 'blank' ?
        state.styleKey : 'blank';
      const artworkUrl = this.artworkUrl(state.generationKey, artworkKey);

      if (!this.active || !artworkUrl) {
        this.showFitGuide(this.active && !artworkUrl);
        return;
      }

      this.error.hidden = true;
      const cacheKey = `${state.generationKey}|${artworkKey}|${artworkUrl}`;
      if (!this.masterCache.has(cacheKey)) this.setBusy(true);

      try {
        const master = await this.getMaster(state.generationKey, artworkKey, artworkUrl);
        if (token !== this.renderToken || !this.isConnected) return;
        await yieldToBrowser();
        if (token !== this.renderToken || !this.isConnected) return;
        this.drawMaster(master, state);
        if (token !== this.renderToken || !this.isConnected) return;
        this.fitGuide.hidden = true;
        this.canvas.hidden = false;
        this.setBusy(false);
      } catch (error) {
        if (error?.name === 'AbortError' || token !== this.renderToken) return;
        console.warn('[Kent Dubs visual configurator]', error);
        this.showFitGuide();
        this.error.hidden = false;
      }
    }

    getMaster(generationKey, key, url) {
      const cacheKey = `${generationKey}|${key}|${url}`;
      if (this.masterCache.has(cacheKey)) return Promise.resolve(this.masterCache.get(cacheKey));
      const pending = this.masterPromises.get(cacheKey);
      if (pending?.buildId === this.masterBuildId) return pending.promise;
      if (pending) this.masterPromises.delete(cacheKey);

      const buildId = ++this.masterBuildId;
      const promise = (async () => {
        const source = await decodeArtwork(url);
        const masks = await buildSentinelMasks(
          source,
          key,
          generationKey,
          () => this.masterBuildId === buildId && this.isConnected
        );
        if (this.masterBuildId !== buildId) throw new DOMException('Stale artwork build', 'AbortError');
        const master = { generationKey, key, source, masks };
        this.masterCache.set(cacheKey, master);
        return master;
      })().finally(() => {
        if (this.masterPromises.get(cacheKey)?.promise === promise) {
          this.masterPromises.delete(cacheKey);
        }
      });
      this.masterPromises.set(cacheKey, { buildId, promise });
      return promise;
    }

    drawMaster(master, state) {
      const source = master.source;
      const bytes = new Uint8ClampedArray(source.data);
      const paintTarget = hexToRgb(state.selectedPaint.hex);
      const coverTarget = hexToRgb(COVER_COLOURS[state.coverKey] || COVER_COLOURS.black);
      const eyeTarget = hexToRgb(EYE_COLOURS[state.eyeKey] || EYE_COLOURS.turquoise);
      const useGreyCover = state.coverKey === 'grey';
      const tintMask = (mask, target, kind) => {
        for (let item = 0; item < mask.pixels.length; item += 1) {
          tintPixel(bytes, mask.pixels[item] * 4, target, mask.alphas[item] / 255, kind);
        }
      };

      tintMask(master.masks.paint, paintTarget, 'paint');
      const coverTintKind = isSprinterGeneration(master.generationKey) ?
        'sprinter-cover' :
        master.key === 'blank' ? 'blank-cover' : 'cover';
      tintMask(master.masks.cover, coverTarget, coverTintKind);
      if (master.masks.neutralCover) {
        tintMask(master.masks.neutralCover, coverTarget, 'sprinter-cover');
      }
      if (master.masks.coverSeam) {
        tintMask(master.masks.coverSeam, coverTarget, 'sprinter-cover');
      }
      const adjustBrow = useGreyCover ? darkenBrow :
        master.key === 'frida' ||
          (isSprinterGeneration(master.generationKey) && master.key === 'sophie') ?
          lightenBrow :
          null;
      if (adjustBrow && master.masks.contrast) {
        const browMask = useGreyCover && master.masks.contrastDark ?
          master.masks.contrastDark :
          master.masks.contrast;
        for (let item = 0; item < browMask.pixels.length; item += 1) {
          adjustBrow(
            bytes,
            browMask.pixels[item] * 4,
            browMask.alphas[item] / 255
          );
        }
      }
      tintMask(master.masks.iris, eyeTarget, 'iris');

      // Write the calculated pixels to a non-visible buffer first, then copy
      // that bitmap into the displayed canvas with drawImage. Browsers can
      // defer a direct putImageData update when the visible canvas sits in a
      // sticky composited layer; drawImage reliably invalidates that layer so
      // every option change appears immediately without requiring a scroll.
      this.paintBuffer.width = source.width;
      this.paintBuffer.height = source.height;
      const bufferContext = this.paintBuffer.getContext('2d', { alpha: false });
      bufferContext.putImageData(new ImageData(bytes, source.width, source.height), 0, 0);

      this.canvas.width = source.width;
      this.canvas.height = source.height;
      const context = this.canvas.getContext('2d', { alpha: false });
      context.drawImage(this.paintBuffer, 0, 0);
    }
  }

  if (!customElements.get('kd-visual-configurator')) {
    customElements.define('kd-visual-configurator', KDVisualConfigurator);
  }
})();
